<template>
  <div class="green__categories">
    <div class="green__column">
      <div class="green__row green__ac">
        <div
            @click="seeСategory = false"
            class="pa-3 green__btn green__mr__xs green__pointer green__see green__row green__ac green__mb__s"
            v-bind:class="{'green__active' : !seeСategory }"
        >
          <i class="fas fa-plus green__mr__xs"></i>
          <p >Добавить категорию</p>
        </div>
        <div
            @click="seeСategory = true"
            class="pa-3 green__btn green__pointer green__see green__row green__ac green__mb__s"
            v-bind:class="{'green__active' : seeСategory }"
        >
          <i class="fas fa-eye green__mr__xs"></i>
          <p >Список категории</p>
        </div>
      </div>

      <form
          @submit.prevent="addCategory"
          class="green__column"
          v-if="!seeСategory"
      >
        <div class="green__choose item__row item__ac">
          <!--                <p-->
          <!--                    class="green__category__choose"-->
          <!--                    @click="chooseParentMain(1)"-->
          <!--                    v-bind:class="{ green__category__active: page_category == 1 }"-->
          <!--                >-->
          <!--                  Главный элемент-->
          <!--                </p>-->
          <!--                <p-->
          <!--                    class="green__category__choose"-->
          <!--                    @click="chooseParentMain(2)"-->
          <!--                    v-bind:class="{ green__category__active: page_category == 2 }"-->
          <!--                >-->
          <!--                  Дочерный элемент-->
          <!--                </p>-->
        </div>

        <div class="item__column green__parents" v-if="page_category === 2">
          <div class="item__wrap item__ac">
            <div
                class="item__row item__ac green__mb__xs green__parents"
                v-for="(cat, c) in categories"
                :key="c"
            >
              <p :class="{'green__category__el': true, 'green__mr__xs':true, 'green__active': c === current_category_index }">{{ cat.name }}</p>
              <div class="item__row item__ac">
                <v-tooltip bottom
                ><template v-slot:activator="{ on, attrs }"
                ><i
                    class="mdi mdi-keyboard-return green__pointer mr-2"
                    v-bind="attrs"
                    v-on="on"
                ></i></template
                ><span>Выбрать категорию</span></v-tooltip
                >
                <v-tooltip bottom
                ><template v-slot:activator="{ on, attrs }"
                ><i
                    v-bind="attrs"
                    v-on="on"
                    class="mdi mdi-format-list-bulleted green__mr__xs green__pointer"
                    @click="getChilds(cat.id, 'parent')"
                ></i></template
                ><span>Показать список</span></v-tooltip
                >
              </div>
            </div>
          </div>

          <div class="item__column" v-if="nested.length !== 0">
            <div
                class="item__row item__ac green__mb__xs green__parents"
                v-for="(cat, c) in nested"
                :key="c"
            >
              <p class="green__category__el green__mr__xs">{{ cat.name }}</p>
              <div class="item__row item__ac">

                <v-tooltip bottom
                ><template v-slot:activator="{ on, attrs }"
                ><i
                    v-bind="attrs"
                    v-on="on"
                    class="mdi mdi-format-list-bulleted green__mr__xs green__pointer"
                    @click="getChilds(cat.id, 'child')"
                ></i></template
                ><span>Показать список</span></v-tooltip
                >
              </div>
            </div>
          </div>

        </div>

        <div class="green__column green__input mb-4">
          <h4 class="mb-1">Название категории</h4>
          <input required v-model="category_name" class="green__input__write" />
        </div>
<!--        <div class="green__column green__input mb-2">-->
<!--          <h4 class="mb-1">Приоритет</h4>-->
<!--          <input v-model="priority" class="green__input__write" />-->
<!--        </div>-->

        <button type="submit">Сохранить</button>
      </form>

      <div class="green__column green__edit" v-else>
        <div
            class="green__btn green__pointer green__see green__row green__ac green__mb__s"
        >
          <p>Выберите категорию</p>
        </div>
        <div class="item__column green__parents">
          <div class="item__wrap item__ac">
            <div
                class="item__row item__ac green__mb__xs green__parents"
                v-for="(cat, c_index) in categories"
                :key="c_index"
            >
              <p
                  @click="getCategoryEdit(c_index,cat.id, 'parent')"
                  :class="{'green__category__el' : true, 'green__mr__xs': true, 'green__pointer':true, 'green__active': c_index === current_category_index}"
              >{{ cat.name }}</p>

            </div>
          </div>

          <div class="item__column" v-if="nested.length !== 0">
            <div
                class="item__row item__ac green__mb__xs green__parents"
                v-for="(cat, c) in nested"
                :key="c"
            >
              <p class="green__category__el green__mr__xs">{{ cat.name }}</p>
              <div class="item__row item__ac">
                <v-tooltip bottom
                ><template v-slot:activator="{ on, attrs }"
                ><i
                    class="mdi mdi-keyboard-return green__pointer mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="getCategoryEdit(cat.id, 'child')"
                ></i></template
                ><span>Выбрать категорию</span></v-tooltip
                >
                <v-tooltip bottom
                ><template v-slot:activator="{ on, attrs }"
                ><i
                    v-bind="attrs"
                    v-on="on"
                    class="mdi mdi-format-list-bulleted green__mr__xs green__pointer"
                    @click="getChilds(cat.id, 'child')"
                ></i></template
                ><span>Показать список</span></v-tooltip
                >
              </div>
            </div>
          </div>
          <p v-if="selected_category" class="green__mb__s">
            Выбранный категория: <b>{{ selected_category }}</b>
          </p>
        </div>

        <form class="green__mb__s" action="" @submit.prevent="editSaveCategory()">
          <div class="green__column green__input">
            <p>Выбранный категория</p>
            <v-text-field
                v-model="category_name_edit"
                label="Категория"
                outlined
            ></v-text-field>
          </div>
<!--          <div class="green__column green__input">-->
<!--            <p>Приоритет</p>-->
<!--            <input v-model="priority" class="green__input__write" />-->
<!--          </div>-->


          <button type="submit">Сохранить</button>
        </form>
        <div class="green__row green__ac" v-if="category_name_edit != ''">
          <div
              class="green__btn green__pointer green__row green__ac green__mb__s"
              @click="openDelete(1, category_id_edit)"
          >
            <i class="fas fa-trash-alt green__mr__xs"></i>
            <p>Удалить</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  data() {
    return {
      current_category_index: '',
      seeСategory: false,
      p_id: '',
      category_name:'',
      category: '',
      priority: '',
      category_name_edit: '',
      nested: [],
      categories: [],
      page_category: '',
      selected_category: '',
      showLoader: '',
      user: {
        id: ''
      },
      page: '',
      category_id_edit: ''
    }
  },
  mounted() {
    if (localStorage.getItem("access_token")) {
      this.token = localStorage.getItem("access_token");
      this.$http
          .post(
              "/get/user/me",
              {},
              {
                headers: {
                  Authorization: `Bearer ${this.token}`,
                },
              }
          )
          .then((res) => {
            console.log("id",res.data.id)
            this.user.id = res.data.id;
            this.page = 1;
            this.user.role = res.data.name;
            this.user = res.data;
            this.getCategories();
            this.getAllCategories();
          });
    } else {
      this.$router.push("/login");
    }
  },
  methods: {
    editSaveCategory() {
      let fd = new FormData();
      fd.append("id", this.category_id_edit);
      fd.append("name", this.category_name_edit);
      fd.append("image", this.category.image);
      fd.append("priority", this.priority);

      this.$http
          .post("/update/category", fd, {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.$toast.open({
              message: res.data.message,
              type: "success",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
            this.getCategories();
          });
    },
    getAllCategories() {
      const config = {
        headers: { Authorization: `Bearer ${this.token}` },
      };
      this.$http.get("/get/all/categories", config).then((res) => {
        this.all_categories = res.data;
      });
    },
    getChilds(id, type) {
      let t = "";
      if (type == "child") {
        t = this.nested.filter((item) => item.id === id);
      } else {
        t = this.categories.filter((item) => item.id === id);
      }

      if (!t[0].p_id) {
        t = this.categories.filter((item) => item.id === id);
      }
      if (t[0].children) {
        this.nested = t[0].children;
      }
    },
    openDelete(index, id) {
      this.dialog = true;
      this.delete_index = id;
      this.delete_type = index;
    },
    getCategoryEdit(index,id, type) {
      this.current_category_index = index
      let t = "";
      if (type == "child") {
        t = this.nested.filter((item) => item.id === id);
      } else {
        t = this.categories.filter((item) => item.id === id);
      }
      this.category_name_edit = t[0].name;

      this.category_id_edit = id;
    },
    addCategory() {
      let fd = new FormData();
      fd.append("p_id", this.p_id);
      fd.append("name", this.category_name);
      fd.append("image", this.category.image);

      this.$http
          .post("/create/category", fd, {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.getCategories();
            this.$toast.open({
              message: res.data.message,
              type: "success",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
          });
    },
    showListCategories() {
      this.seePurchase = false;
      this.getCategories();
    },
    getCategories() {
      const config = {
        headers: { Authorization: `Bearer ${this.token}` },
      };
      this.$http.get("/get/categories", config).then((res) => {
        this.categories = res.data;
      });
    },
    createProduct() {
      console.log("size",typeof this.size)

      this.createLoader = true;


      if (!this.category_id) {
        alert("Выберите категорию");
      }
      let fd = new FormData();
      fd.append("name", this.title);
      fd.append("category_id", this.category_id);
      fd.append("price", this.price);
      fd.append("count", this.count);
      fd.append("count_type", this.count_type);
      fd.append("articul", this.articul);
      fd.append("sizes", JSON.stringify(this.size));
      fd.append("heights", JSON.stringify(this.height));

      for (var i = 0; i < this.documents.length; i++) {
        fd.append("images[]", this.documents[i]);
      }
      fd.append("description", this.description);
      this.$http
          .post("/create/product", fd, {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.createLoader = false;
            this.$toast.open({
              message: res.data.message,
              type: "success",
              position: "bottom",
              duration: 5000,
              queue: true,
            });

            this.documents = [];

            this.message_notif = res.data.message;
            this.getCategories();
            this.getProductByCategory(this.category_id, null);

            this.seePurchase = true;
          });
    },
  }
}
</script>


<style scoped lang="less">
.admin__loader {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  z-index: 10;
  bottom: 0;
  background-image: linear-gradient(
      to right,
      #253532,
      #1e363d,
      #273345,
      #3c2e43,
      #4c2934
  );

  i {
    font-size: 36px;
    color: white;
  }
  p {
    font-size: 36px;
    color: white;
  }
}
@mobile: 900px;
@planshet: 1200px;
.mdi-logout {
  font-size: 26px;
  position: absolute;
  right: 20px;
  color: white;
  top: 20px;
}
.bonus__actions {
  width: 100%;
  z-index: 10;
  position: fixed;
  background: #191a21;
  bottom: 0;
  padding: 20px;
  .bonus__actions__btn {
    i {
      color: white;
      font-size: 32px;
    }
  }
  // p {
  //     padding: 15px;
  //     background-image: linear-gradient(to right, #131215, #1d161e, #2b1824, #3a1924, #481b20);
  //     border-radius: 20px;
  //     color: white;
  //     text-align: center;
  //     font-weight: bold;
  //     cursor: pointer;
  //     @media (max-width: @mobile) {
  //        padding: 10px;
  //        font-size: 14px;
  //     }
  // }
}
.modal__bonus {
  .modal__bonus__title {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: #4c2934;
  }
  .modal__bonus__result {
    margin-bottom: 10px;
    p {
      font-size: 18px;
      color: #0069ff;
      span {
        font-weight: bold;

        font-size: 20px;
      }
    }
  }
  .modal__bonus__label {
    margin-bottom: 15px;
  }
  input {
    padding: 10px;
    outline: none;
    border: 1px solid #ccc;
  }

  .modal__bonus__btn {
    border-radius: 20px;
    padding: 20px;
    text-align: center;
    justify-content: center;
    background-image: linear-gradient(
        to right,
        #253532,
        #1e363d,
        #273345,
        #3c2e43,
        #4c2934
    );
    p {
      color: white;
      font-weight: bold;
    }
    i {
      color: white;
    }
  }
}



.green__active {
  background: #0069ff;
  color: white;
  padding: 5px;
}
.banners {
  overflow-x: scroll;
  i {
    cursor: pointer;
  }
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
}
.green__notif_position {
  bottom: 200px;
}
p {
  margin-bottom: 0 !important;
}

.green__mb__xs {
  margin-bottom: 10px;
}
.green__mb__s {
  margin-bottom: 20px !important;
}
.green__ml__l {
  margin-left: 20px;
}
.green__mr__xs {
  margin-right: 10px;
}
.green__100 {
  width: 100%;
}
.green__row {
  display: flex;
  flex-direction: row;
}
.green__ac {
  align-items: center;
}
.green__jb {
  justify-content: space-between;
}
.green__column {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  @media (max-width: @mobile) {
    width: 100%;
  }
}
.green__abs {
  display: flex;
  justify-content: center;
  align-items: center;
}

.green__pointer {
  cursor: pointer;
}

.green__btn__color {
  color: #0069ff;
}
.green__btn__color:hover {
  opacity: 0.6;
}

.green__admin {
  min-height: 100vh;

  align-items: center;
  justify-content: center;

  .green__see {
    font-size: 18px;
    font-weight: bold;
    @media (max-width: 900px) {
      font-size: 12px;
      white-space: nowrap;
    }
  }
  .green__see--active {
    color: #0069ff;
  }
  .green__images__title {
    margin-top: 40px;
    color: #0069ff;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .green__product__images__main::-webkit-scrollbar {
    height: 5px;
  }

  .green__product__images__main::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #ccc;
  }
  .green__product__images__main::-webkit-scrollbar-thumb {
    background-color: #0069ff;
    border-radius: 2px;
    height: 24px;
    width: 50px;
  }
  .green__product__images__main {
    overflow-x: auto;
    width: 50%;
  }
  .green__product__images {
    margin-bottom: 5px;
    margin-top: 5px;
    img {
      width: 70px;
      height: 70px;
      border-radius: 10px;
      object-fit: cover;
      margin-right: 30px;
    }
  }

  .green__logout {
    align-self: flex-end;
    padding: 10px;
    background-image: linear-gradient(
        to right,
        #253532,
        #1e363d,
        #273345,
        #3c2e43,
        #4c2934
    );
    color: white;
    margin-bottom: 20px;
    width: 140px;
    text-align: center;
  }
  .green__logout:hover {
    background: #5c8a0d;
  }

  .green__left {
    width: 20%;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 2px;

    margin-right: 20px;
    min-height: 100px;
    border-radius: 10px;

    @media (max-width: @mobile) {
      width: 100%;
      margin-left: 0;
      margin-bottom: 20px;
    }

    p {
      font-weight: bold;
      cursor: pointer;
    }
    i {
      color: white;
    }
  }

  .green__right {
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 10px;


    i {
      color: white;
    }

    .green__parents {

      .green__category__el {
        border: 1px solid black;
        padding: 5px;
        margin-right: 20px;
        min-width: 100px;
        text-align: center;
        border-radius: 20px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
      }
      p {
        font-size: 20px;
      }
      i {
        background: #0069ff;
        padding: 10px;
        font-size: 22px;
        border-radius: 50%;
        margin-right: 10px;
      }
      i:hover {
        opacity: 0.8;
      }
    }
    .green__choose {
      margin-bottom: 20px;
      .green__category__choose {
        cursor: pointer;
        padding: 20px;
        background: gray;
        margin-right: 10px;
        color: white;
        @media (max-width: @mobile) {
          font-size: 14px;
        }
        border-radius: 20px;
      }
      .green__category__active {
        background: #0069ff;
      }
    }

    .green__input {
      width: 300px;
      @media (max-width: @mobile) {
        width: 100%;
      }
      .green__input__write {
        border: 1px solid black;
        padding: 20px;
        border-radius: 2px;
        outline: none;
      }
    }
    button {
      width: 300px;
      outline: none;
      border: none;
      padding: 20px;
      border-radius: 20px;
      background: #0069ff;
      color: white;
      @media (max-width: @mobile) {
        width: 100%;
      }
    }

    .green__edit {
      margin-bottom: 20px;
      border-radius: 2px;
      border: 1px solid #ccc;
      padding: 20px;

      a {
        color: #0069ff !important;
      }

      .green__user__orders {
        margin-top: 30px;
        margin-left: 10px;

        .green__user__title {
          font-weight: bold;
          font-size: 18px;
        }
      }

      @media (max-width: @mobile) {
        margin-left: 0;
      }
      .green__last__action {
        p {
          font-size: 12px;
        }
      }

      .green__data {
        margin-bottom: 10px;
        color: #0069ff;
        font-size: 18px;
      }
      .green__save__btn {
        color: #0069ff;
      }

      button {
        width: 300px;
        outline: none;
        border: none;
        background-color: #0069ff;
        color: white;
        padding: 20px;
        @media (max-width: @mobile) {
          width: 100%;
        }
      }
    }
  }
}

.green__message {
  button {
    outline: none;
    border: none;
    background-color: #0069ff;
    color: white;
    padding: 20px;
  }
}

.green__admin__inner {
  @media (max-width: @mobile) {
    flex-direction: column;
  }
}
</style>
